import * as React from 'react'
import { useCallback } from 'react'
import { toast } from '@sales-center/components'
import {
  bulkUpdateExpectedClosingDate,
  bulkUpdateNextActionDate,
} from '@user/store/opportunity'
import {
  BulkActionsProps,
  BulkUpdateNextActionDate,
} from '@user/components/xGrid'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { ENTITY_TYPES } from '@sales-center/common'

type Props = BulkActionsProps & { hasPermission: boolean }
export const OpportunityBulkUpdateNextActionDate: React.FC<Props> = ({
  selectedRows,
  hasPermission,
}) => {
  const dispatch = useAppDispatch()

  const updateCallback = useCallback(
    async (date: Date | null, updateExpected: boolean) => {
      const ids = [...selectedRows.keys()].map((k) => Number(k))
      const result = await dispatch(
        bulkUpdateNextActionDate({
          ids: ids,
          nextActionDate: date,
        }),
      )
      if (updateExpected) {
        await dispatch(
          bulkUpdateExpectedClosingDate({
            mode: 'commit',
            model: {
              ids: ids,
              expectedClosingDate: date,
            },
          }),
        )
      }
      if (bulkUpdateNextActionDate.fulfilled.match(result)) {
        toast.success('Bulk update successfully applied')
        return true
      } else {
        if (result.payload) toast.error(result.payload.Message)
        return false
      }
    },
    [dispatch, selectedRows],
  )

  return (
    <BulkUpdateNextActionDate
      recordCount={selectedRows.size}
      saveCallback={updateCallback}
      hasPermission={hasPermission}
      entityType={ENTITY_TYPES.Opportunity}
    />
  )
}
OpportunityBulkUpdateNextActionDate.displayName =
  'OpportunityBulkUpdateNextActionDate'
